import axios from "axios";
import { useEffect, useState } from "react";
import { Accordion, Breadcrumb, Col, Container, Row } from "react-bootstrap";
import window11productgroup from "../../../Assets/images/window11 productgroup.png";
import microsoftAuthorizedReseller from "../../../Assets/images/microsoft_authorized_reseller.png";
import window7product1 from "../../../Assets/images/window7ultprod1.png";
import window7product2 from "../../../Assets/images/window7Ultprod2.png";
import window7product3 from "../../../Assets/images/window7ultprod3.png";
import { useNavigate } from "react-router-dom";
import { apiBaseURL } from "../../../Common/ApiHelper";
import { ToastContainer, toast } from "react-toastify";

const Window7Home = ({ id }) => {
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cart, setCart] = useState([]);
  const [added, setAdded] = useState(
    localStorage.getItem("addedProducts")
      ? localStorage.getItem("addedProducts")
      : []
  );

  const fetchData = async () => {
    try {
      const response = await axios({
        method: "get",
        url: `${apiBaseURL}user/getProductById/?productId=${id}`,
      });
      if (response?.status === 200) {
        setTableData(response.data.data);
        setLoading(false);
      }
    } catch (e) {
      toast.error(e.message);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    if (localStorage.getItem("cartItems")) {
      setCart(JSON.parse(localStorage.getItem("cartItems")));
    } else {
      localStorage.setItem("cartItems", JSON.stringify([]));
    }
  }, []);

  const handleAddCart = (product) => {
    product.quantity = 1;
    localStorage.setItem("cartItems", JSON.stringify([...cart, product]));
    setCart([...cart, product]);
    const updatedArray = JSON.parse(localStorage.getItem("cartItems")).map(
      (items) => items._id
    );
    setAdded(updatedArray);
    localStorage.setItem("addedProducts", JSON.stringify(updatedArray));
    toast.info("Product Added", {
      position: "top-right",
      autoClose: 100,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "light",
    });
    navigate(`${window.location.pathname}`);
  };
  return (
    <>
      <ToastContainer />
      <div className="main pt-4 pb-5">
        <Container>
          <div className="product_breadcrumb">
            <Breadcrumb>
              <Breadcrumb.Item onClick={() => navigate("/")}>
                Home
              </Breadcrumb.Item>
              <Breadcrumb.Item
                onClick={() => navigate("/category/MicrosoftOffice")}
              >
                Shop
              </Breadcrumb.Item>
              <Breadcrumb.Item active>Windows 7 Home</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          {loading ? (
            <>
              <div class="d-flex justify-content-center ">
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="product_details_with_image box_shadow">
                <Row>
                  <Col xxl="3" lg="3" md="12">
                    <div className="product_image pt-4">
                      <img
                        src={tableData.productImage}
                        alt="Product"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </Col>
                  <Col xxl="7" lg="7" md="12">
                    <div className="product_details pt-5 pb-4">
                      <h1>{tableData.name}</h1>
                      <p className="retail_version_color">
                        Retail Version |{" "}
                        {tableData?.retailVersion[0]?.split(":").join(": ")}
                      </p>
                      <img
                        src={window11productgroup}
                        alt="Product inner products images"
                        className="mb-4"
                      />
                      <div className="include_product_purchase">
                        <h1 className="font-weight-bold">
                          Included In Your Purchase:
                        </h1>
                        <p>
                          Download Your Software Directly From Microsoft
                          <br />
                          Activation Key For Windows 7 Home <br />
                          PDF Intructions For Download & Activation <br />
                          Lifetime Live Chat Support & Assistance
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col xxl="2" lg="2" md="12">
                    <div className="price_details pt-5 pb-4">
                      <p className="font-weight-bold product_price mb-0">
                        ${tableData.salePrice} USD
                      </p>
                      {added.includes(tableData._id) ? (
                        <button
                          className="product_page_addCart_btn box_shadow"
                          onClick={() => navigate("/cart")}
                        >
                          Go To Cart
                        </button>
                      ) : (
                        <button
                          className="product_page_addCart_btn box_shadow"
                          onClick={() => handleAddCart(tableData)}
                        >
                          Add To Cart
                        </button>
                      )}

                      <div className="product_have_questions">
                        <h3>Have Questions?</h3>
                        <p>
                          Call +1 (833) 465 0300 <br /> or contact us via chat
                        </p>
                      </div>
                      <div className="microsoft_partner">
                        <img
                          src={microsoftAuthorizedReseller}
                          alt="productgroupImg"
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </>
          )}

          <div className="extraInfo_tabs mt-4">
            <Row>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4">
                  <h5>Licensing</h5>
                  <p className="mb-0">Retail</p>
                </div>
              </Col>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4">
                  <h5>Licensing Term</h5>
                  <p className="mb-0">Lifetime</p>
                </div>
              </Col>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4">
                  <h5>Users Supported</h5>
                  <p className="mb-0">1 User </p>
                </div>
              </Col>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4">
                  <h5>Devices Supported</h5>
                  <p className="mb-0">1 Device </p>
                </div>
              </Col>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4">
                  <h5>Delivery Method</h5>
                  <p className="mb-0">Instant Digital Delivery</p>
                </div>
              </Col>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4   ">
                  <h5>Platform Supported</h5>
                  <p className="mb-0">Windows</p>
                </div>
              </Col>
            </Row>
          </div>
          <div className="product_long_description">
            <Row>
              <Col xxl="9" md="9" sm="12">
                <div className="box_shadow mb-2 me-3">
                  <div className="product_main_description">
                    <h3 className="mb-0">Product Description</h3>
                    <p className="window7_product_description mt-4">
                      For all demanding home users, Microsoft offers the optimal
                      operating system with Windows 7 Home Premium. It features
                      numerous improvements compared to its predecessor Windows
                      Vista. In addition to the exclusive content, consisting of
                      numerous media programs, there are functions to increase
                      the performance of the user interface and in the security
                      area.
                    </p>
                  </div>
                  <div className="product_white ">
                    <div className="row product_main_description mx-0 pt-0 pb-4">
                      <div className="col-xl-7 p-0 d-flex flex-column justify-content-center">
                        <p className="me-5 mb-0 window7_product_description window7_spacing pb-5">
                          With Windows 7 Home Premium, Microsoft gives you an
                          operating system that stands out with a modern user
                          interface, new features and other simplifications. For
                          example, the developers have provided numerous
                          programs such as WordPad and Paint with a ribbon menu
                          bar. For this reason, you have the important tools
                          permanently in view and make your work even more
                          efficient. For example, you can use the Multi-Touch
                          feature to draw in Paint with multiple fingers
                          simultaneously using the touch screen. With Windows 7
                          Home Premium, you’re no longer limited by Sidebar, and
                          you can place widgets on your desktop at any time.
                          <br />
                          <br />
                          <br />
                          With the new DirectX 11, your system will also be
                          improved in terms of performance. This provides
                          Windows Home 7 Premium with the necessary support to
                          handle even complex graphic processes without
                          problems. The speed of the operating system, which is
                          significantly faster than its predecessor Windows
                          Vista, is strikingly positive.
                        </p>
                      </div>
                      <div className="col-xl-5 p-0 d-flex flex-column justify-content-center">
                        <img
                          className=" heading_img pb-5 w-100"
                          src={window7product1}
                          alt="productDescription"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="product_grey pt-5 pb-5">
                    <div className="row product_main_description mx-0 product_grey pt-0 pb-2">
                      <div className="col-xl-5 p-0 d-flex flex-column justify-content-center">
                        <img
                          className="product_grey heading_img pt-5 w-100"
                          src={window7product2}
                          alt="productDescription"
                        />
                      </div>
                      <div className="col-xl-7 p-0 d-flex flex-column justify-content-center">
                        <p className="ms-5 pt-4 window7_product_description window7_spacing">
                          The repertoire of new features in Microsoft Windows 7
                          Professional is enormous: To optimize the system
                          performance and user interface, Microsoft has
                          integrated the Security Center, which monitors the
                          firewall and virus scanner status. The error logging
                          program also provides detailed problem reports. With
                          the improved Windows search you will navigate faster
                          and more precisely in the future. The virtual folder
                          of Windows 7 Professional also provides quick access
                          to data in the so-called libraries. In addition to
                          touch support, it is now much more intuitive to create
                          home networks.
                          <br />
                          <br />
                          <br />
                          Microsoft Windows 7 Professional supports HDTV and DVD
                          writing and playback. You will also receive the
                          Windows Media Center, Media Player and some games with
                          your purchase. Some unnecessary taskbar and explorer
                          functions are no longer included for optic purposes.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="product_white bottom_radius">
                    <div className=" product_main_description pt-5">
                      <p className="window7_product_description mt-4">
                        Microsoft has also worked on security issues: Windows 7
                        Ultimate now comes standard with biometric
                        authentication, which allows you to log in to your
                        profile using your fingerprint. In addition, you have
                        the possibility to grant rights increases to certain
                        users. In addition, Windows 7 Ultimate works with a
                        whitelist for system programs, where no further
                        confirmation is requested during execution. With the
                        help of the blacklist, on the other hand, you can keep
                        track of critical programs, which are then treated
                        separately when used.
                      </p>
                    </div>
                    {/* <div className=" d-flex product_main_description pt-0 pb-5 bottom_radius"> */}
                    <div className="row product_main_description mx-0 pt-0 pb-5 mb-5 bottom_radius">
                      <div className="col-xl-7 p-0 d-flex flex-column justify-content-center">
                        <p className="me-5 window7_product_description window7_spacing ">
                          A further optimization step in Microsoft Windows 7
                          Professional is the removal of various programs, the
                          classic Start menu as well as various functions in the
                          taskbar, the Windows Media Player and Explorer
                          features. <br />
                          <br />
                          <br />
                          For this you get some new options in Windows 7
                          Professional: This includes for example the support of
                          Windows Server Domains.
                          <br />
                          <br />
                          <br />
                          With XP mode, you can still use older programs. In
                          addition, each purchaser will receive an Extended
                          Support period after the mainstream support period
                          with the Microsoft Windows 7 Professional operating
                          system has expired.
                        </p>
                      </div>
                      <div className="col-xl-5 p-0 d-flex flex-column justify-content-center">
                        <img
                          className=" heading_img w-100"
                          src={window7product3}
                          alt="productDescription"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="product_accordion mt-5 me-3">
                  <Accordion>
                    <Accordion.Item eventKey="0" className=" box_shadow">
                      <Accordion.Header>
                        What is a digital download?
                      </Accordion.Header>
                      <Accordion.Body>
                        A digital download is an electronic version of your
                        software product which gives you access to download and
                        use your software immediately. This means a physical
                        package is not included with your purchase. You will
                        have the option to create a disc or USB at home or in
                        the office. Our support team would be happy to help
                        guide you through the process.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1" className=" box_shadow">
                      <Accordion.Header>
                        What is the difference between OEM & Retail licenses?
                      </Accordion.Header>
                      <Accordion.Body>
                        OEM licenses are pre-installed on the device and are
                        backed by the vendor. Retail licenses are powered by
                        Microsoft. You are free to install your product on any
                        device. Retail versions may be transferred to new
                        hardware but may only be installed on one device at a
                        time.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2" className=" box_shadow">
                      <Accordion.Header>
                        How can I guarantee that my copy of Microsoft software
                        is authentic?
                      </Accordion.Header>
                      <Accordion.Body>
                        Liberty Programs only purchases and distributes software
                        and licensing keys through our trusted Microsoft Partner
                        vendors. <br />
                        Any software purchased from Liberty Programs is covered
                        by our hassle-free 90-day money-back guarantee. We
                        encourage all of our customers to register their
                        Microsoft product key via the Microsoft phone activation
                        to ensure authenticity of their purchased products.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3" className=" box_shadow">
                      <Accordion.Header>
                        Will my license key expire?
                      </Accordion.Header>
                      <Accordion.Body>
                        No, any product purchased from Liberty Programs is a
                        retail version which includes a lifetime license of your
                        software.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4" className=" box_shadow">
                      <Accordion.Header>
                        How long until I recieve my order?
                      </Accordion.Header>
                      <Accordion.Body>
                        Your order will typically be processed immediately.
                        Please login in to your account area with the
                        credentials given during the checkout process to find
                        your download media and license keys.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="5" className=" box_shadow">
                      <Accordion.Header>
                        How do I download my software?
                      </Accordion.Header>
                      <Accordion.Body>
                        You can access your download media for your purchased
                        software in your account area.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="6" className=" box_shadow">
                      <Accordion.Header>
                        Where can I find the license keys to activate my
                        software
                      </Accordion.Header>
                      <Accordion.Body>
                        You can access your license key for your purchased
                        products in your account area.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="7" className=" box_shadow">
                      <Accordion.Header>
                        How do I get help with my installation?
                      </Accordion.Header>
                      <Accordion.Body>
                        We offer a step-by-step PDF document that walks you
                        through the download process . If you need more
                        assistance please contact our support team and we would
                        be happy to help you with the installation via chat or
                        remote installation.
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </Col>
              <Col xxl="3" md="3" sm="12">
                <div className="product_sidebar_widget darkblue_bg box_shadow">
                  <h4>256-bit SSL Encrypted Checkout</h4>
                  <p>
                    All personal information is protected by state of the art
                    SSL certified encryption.{" "}
                  </p>
                  <hr />
                  <h4>24/7 Tech Support Available</h4>
                  <p>
                    Your purchase with Liberty Programs includes around the
                    clock support from our technical experts. <br />
                    <br />
                    Our team of highly trained professionals make software
                    installations a breeze, helping to identify problems and
                    provide immediate solutions that may arise during and after
                    the installation of software.
                  </p>
                  <hr />
                  <h4>Your Business Is Important To Us</h4>
                  <p>
                    We value our customers and appreciate your business with us.
                    <br />
                    <br />
                    Whether you're an individual upgrading your software or a
                    business upgrading their network, we're here 24/7 to provide
                    hands on support and troubleshooting.
                    <br />
                    <br />
                    All software downloads are provided directly from Microsoft
                    with a genuine license key for activation. <br />
                    <br />
                    If you have any concerns regarding the authenticity of your
                    software, please call (833) 465 0300 or contact us via chat
                  </p>
                  <hr />
                  <h4>90-Day Money Back Guarantee</h4>
                  <p>
                    If for any reason you are not completely satisfied with your
                    purchase from us please contact our refund department
                    directly at sales@libertyprograms.com
                    <br />
                    <br />
                    If we cannot resolve your ticket, a full refund will be
                    issued regardless of our 90-day money back guarantee. <br />
                    <br />
                    Terms & conditions apply.
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Window7Home;
